import React, { Component } from 'react';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HeadContainer, InputCol, LevelRowContainer, MainWrapper, RoundedWrapper } from './styles';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { Label } from 'components/atoms/Texts/TxtLabel';
import FormTxt from 'components/atoms/Inputs/FormTxt';
import FormSelect from 'components/atoms/Inputs/FormSelect';
import { getAllList } from 'services/cmsService';
import { LOADING_REQUEST } from 'fixtures/api';

export class ActualLoadingInProcessLoadingForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      options: []
    }
  }

  componentDidMount(){
    this.fetchTugboatBarge()
  }

  fetchTugboatBarge = async () => {
    try {
      this.props.toggleIsLoading(true)
      const data = await getAllList(LOADING_REQUEST)
      this.setState({ options: data.map(d => ({...d, name: `${d.tug}/${d.barge}`})) })
    } catch (error) {
      console.error(error);
    } finally {
      this.props.toggleIsLoading(false)
    }
  }

  onChange(field, val) {
    const { form: { inProcessLoading }, onChange } = this.props
    inProcessLoading[field] = val
    if ( field === 'tugboatBarge') {
      const loadingRequest = this.state.options.find(d => d.name === val)
      inProcessLoading.quality = loadingRequest.coalQuality
      inProcessLoading.planCargo = loadingRequest.bargeSize
    }
    onChange('inProcessLoading', inProcessLoading)
  }

  renderTextInput(label, key, placeholder, inputProps) {
    const { form: { inProcessLoading }, theme } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px'
    }

    return (
      <InputCol>
        <Label lineheight={'14px'} size={'12px'}>
          {label}
        </Label>
        <FormTxt
          placeholder={placeholder}
          mb={'16px'}
          value={inProcessLoading ? inProcessLoading[key] : null}
          onChangeVal={e => this.onChange(key, e.target.value)}
          {...inputConfig}
          {...inputProps}
        />
      </InputCol>
    )
  }

  renderPicker(label, key, placeholder, options, ...rest){
    const { form: { inProcessLoading } , theme } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px'
    }
    return (
      <InputCol>
        <Label lineheight={'14px'} size={'12px'}>
          {label}
        </Label>
        <FormSelect
          placeholder={placeholder}
          onChangeVal={e => this.onChange(key, e.target.value)}
          options={options}
          value={inProcessLoading ? inProcessLoading[key] : '-'}
          valField={'name'}
          dispField={'name'}
          arrowSize={'3%'}
          {...inputConfig}
          {...rest}
        />
      </InputCol>
    )
  }

  render() {
    return (
        <RoundedWrapper gap="20px">
          <MainWrapper>
            <HeadContainer>
              <Label lineheight={'29px'} size={'16px'} mb={'0px'}>
                In Process Loading
              </Label>
            </HeadContainer>
              <LevelRowContainer isTop>
                {this.renderPicker('Tugboat/Barge', 'tugboatBarge', 'Select tugboat/barge', this.state.options || [] )}
                {this.renderTextInput('Quality', 'quality', 'Quality' )}
                {this.renderTextInput('Plan Cargo', 'planCargo', 'Plan Cargo' )}
              </LevelRowContainer>
          </MainWrapper>
        </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActualLoadingInProcessLoadingForm)
  )
);
